module.exports = __webpack_public_path__ + "static/media/3Circle.cc268a63.svg";